export const INVALID_CLOUDFLARE_TURNSTILE_TOKEN = 'Please verify you are human and try again'
